import axios from 'axios';
// 创建 axios 实例
const javaHttp = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_JAVA,
    timeout: 0, // 无超时限制，一直等待响应
    headers: {
        'Content-Type': 'application/json',
    },
});
// 请求拦截器
javaHttp.interceptors.request.use((config) => {
    // 可以在这里添加 token 等认证信息
    const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('发送请求:', config);
    return config;
}, (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
});
export default javaHttp;
